'use client'
import React, { useEffect, useRef } from 'react'
import spiderBg from '@/assets/images/wg.svg'

function WagonWheelChart(data: any) {
  const svgRef = useRef<SVGSVGElement | null>(null)

  useEffect(() => {
    drawWagonWheel(data?.data)
  }, [data])

  function drawWagonWheel(data: any) {
    const element = document?.getElementById('wagonWheel')
    const svg = svgRef.current
    if (!svg || !element) return

    // Clear previous content
    svg.innerHTML = ''
    const centerX: any = element?.clientHeight && element?.clientHeight / 2
    const centerY: any = element?.clientWidth && element?.clientWidth / 2

    // Draw shots
    data?.forEach((type: any) => {
      type?.list?.forEach((shot: any) => {
        const line = document.createElementNS('http://www.w3.org/2000/svg', 'line')
        line.setAttribute('x1', centerX)
        line.setAttribute('y1', centerY)
        line.setAttribute('x2', shot?.x)
        line.setAttribute('y2', shot?.y)
        line.setAttribute('stroke', getColorForShot(type.type))
        line.setAttribute('stroke-width', '2')
        svg.appendChild(line)
      })
    })
  }

  // Function to get the color based on the shot type
  function getColorForShot(type: string) {
    switch (type) {
      case '1s':
        return '#0000FE'
      case '2s':
        return '#00FFFF'
      case '3s':
        return '#FEC200'
      case '4s':
        return '#FF29FF'
      case '6s':
        return '#FE0000'
      default:
        return 'black'
    }
  }

  return (
    <>
      <div
        style={{
          backgroundImage: `url(${spiderBg.src})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain'
          // mixBlendMode: 'lighten'
        }}
        className="flex justify-center items-center h-[440px] w-[440px] md:scale-95 scale-[0.7] shrink-0 my-2  md:my-8 "
      >
        <svg
          ref={svgRef}
          preserveAspectRatio="none"
          id="wagonWheel"
          className="h-[400px] w-[400px] "
        ></svg>
      </div>
    </>
  )
}

export default WagonWheelChart
